import React from 'react';

import camelCaseToTitleCase from 'common/util/camelCaseToTitleCase';
import getNullEmptyValue from 'common/util/getNullEmptyValue';
import { formatPrice } from 'common/formatters';

import { transformBooleanToYesNo } from 'client/helpers/formikHelpers';

import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

export function makeAccountingDashboardRows({ rows, highlightRowId, setHighlightRowId }) {
  return rows.map((row) => ({
    onClick: () => {
      setHighlightRowId(row.id);
    },
    className: highlightRowId === row.id ? 'highlighted' : '',
    cells: [
      {
        dataTableFieldId: 'renterName',
        label: 'Renter Name',
      },
      {
        dataTableFieldId: 'renterNumber',
        label: 'Renter Number',
      },
      {
        dataTableFieldId: 'partnerName',
        label: 'Partner',
      },
      {
        dataTableFieldId: 'addressStreetDisplay',
        label: 'Address',
      },
      {
        dataTableFieldId: 'addressStateCode',
        label: 'State',
      },
      {
        dataTableFieldId: 'providerName',
        label: 'Provider',
      },
      {
        label: 'UPT Link',
        content: (
          <SrLink
            to={
              `/utility-profit/admin/processing/${row.utilityActivationShortId}` +
              `?backUrl=${encodeURIComponent('/utility-profit/admin/dashboard/accounting')}` +
              `&backTitle=${encodeURIComponent('Back to Accounting Dashboard')}`
            }
            target="_blank"
          >
            <SrText
              font="greycliff"
              color="blue300"
              cursor="pointer"
              weight="800"
              fontSize="16px"
              lineHeight="50px"
            >
              Link
            </SrText>
          </SrLink>
        ),
      },
      {
        dataTableFieldId: 'invoiceAmount',
        label: 'Actual Revenue to UP',
        value: typeof row.invoiceAmount === 'number' ? formatPrice(row.invoiceAmount) : '--',
      },
      {
        dataTableFieldId: 'payoutAmount',
        label: 'Payout to Partner',
        value: typeof row.payoutAmount === 'number' ? formatPrice(row.payoutAmount) : '--',
      },
      {
        dataTableFieldId: 'activationStatus',
        label: 'Activation Status',
        value: camelCaseToTitleCase(row.activationStatus),
      },
      {
        dataTableFieldId: 'activationCancelReason',
        label: 'Activation Cancel Reason',
        value: camelCaseToTitleCase(row.activationCancelReason),
      },
    ].map((cell) => {
      const rawValue = 'value' in cell ? cell.value : row[cell.dataTableFieldId];
      const content = cell.content
        ? cell.content
        : typeof rawValue === 'boolean'
        ? transformBooleanToYesNo(rawValue, true)
        : getNullEmptyValue(rawValue, '--');

      return {
        ...cell,
        content,
      };
    }),
  }));
}

const emptyRowCells = makeAccountingDashboardRows({ rows: [{}] })[0].cells;

export const accountingDashboardHeaders = emptyRowCells.map(({ dataTableFieldId, label }) => ({
  dataTableFieldId: dataTableFieldId,
  content: label,
  sortPosition: 'right',
}));
